<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Leave Closing Balance
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-4">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client')" placeholder="Select Branch">
                </ng-select>
            </div>

            <div class="col-md-4">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                    [(ngModel)]="Filter.ClientId" (change)="ComboLoad('Site')" placeholder="Select Client">
                </ng-select>
            </div>

            <div class="col-md-4">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="Filter.SiteId" placeholder="Select Site">
                </ng-select>
            </div>

            <div class="col-md-4">
                <label class="Label">Employee Code</label>
                <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Filter.EmpCode"
                    placeholder="Employee Code" />
            </div>

            <!-- <div class="col-md-3 mt-1">
                <label class="Label">Employee Type: </label>
                <div class="btn-group btn-group-toggle ms-2">
                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                            [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}" required>
                        Front Office
                    </label>
                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                            [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}" required>
                        Back Office
                    </label>
                </div>
            </div> -->

            <div class="col-md-auto mt-4">
                <button (click)="LeaveBalanceLoad(0, false)" class="btn btn-primary btn-sm"> Search <i class="bi bi-search ms-2"></i></button>
            </div>
        </div>

        <hr>

        <div class="mx-1 mt-4">
            <table *ngIf="showTable" datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered overflow-auto customeDatatable">
                <thead>
                    <tr>
                        <th style="width:5px">#</th>
                        <th style="width:5px">Action</th>
                        <th *ngFor="let e of Keys; let i = index">
                            {{e}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let e of TableDatas; let i = index">
                        <th>{{i+1}}</th>
                        <td class="text-center"><i (click)="LeaveBalanceLoad(e['EmpMasterID'], true)" class="bi bi-pencil-square text-warning cursor-pointer"></i></td>
                        <td *ngFor="let d of Keys; let i = index">
                            {{e[d]}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>